import { baseServerUrl } from "../utils/constant";
import { defineUrlIcon } from "../utils/defineUrlIcon";
export var Logo2GisRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/Logo2GisRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var Logo2GisSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/Logo2GisSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoAkbars = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoAkbars.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoAlfabank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoAlfabank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoApplemusicRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoApplemusicRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoApplemusicSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoApplemusicSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoArvand = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoArvand.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoBeelineColor = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoBeelineColor.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoBeelineMonochrome = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoBeelineMonochrome.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoBspb = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoBspb.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoDomrfbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoDomrfbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoEnergobank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoEnergobank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoEnergotransbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoEnergotransbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoFinambank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoFinambank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoGazprombank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoGazprombank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoGoskey = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoGoskey.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoGosuslugiRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoGosuslugiRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoGosuslugiSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoGosuslugiSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoHomecredit = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoHomecredit.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoHumo = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoHumo.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoKinopoiskRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoKinopoiskRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoKinopoiskSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoKinopoiskSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoMaestro = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoMaestro.svg"),
  multiColor: false
});
export var LogoMastercard = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoMastercard.svg"),
  multiColor: false
});
export var LogoMinbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoMinbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoMir = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoMir.svg"),
  ratio: 1.9166666666666667,
  multiColor: false
});
export var LogoMkb = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoMkb.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoModulbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoModulbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoMosEnergoSbit = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoMosEnergoSbit.svg"),
  defaultSize: 46,
  multiColor: false
});
export var LogoNationalStandardBank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoNationalStandardBank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoOdnoklassnikiRoundColor = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoOdnoklassnikiRoundColor.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoOdnoklassnikiRoundMonochrome = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoOdnoklassnikiRoundMonochrome.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoOdnoklassnikiSquareColor = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoOdnoklassnikiSquareColor.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoOdnoklassnikiSquareMonochrome = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoOdnoklassnikiSquareMonochrome.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoOpen = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoOpen.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoOzonbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoOzonbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoPochtabank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoPochtabank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoPrimsotsbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoPrimsotsbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoRaiffeisen = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoRaiffeisen.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoRencredit = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoRencredit.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoRosbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoRosbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoRosselkhozbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoRosselkhozbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoRsb = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoRsb.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoRutubeRoundColor = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoRutubeRoundColor.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoRutubeRoundMonochrome = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoRutubeRoundMonochrome.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoRutubeSquareColor = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoRutubeSquareColor.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoRutubeSquareMonochrome = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoRutubeSquareMonochrome.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoSberPayBackground = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoSberPayFilled.svg"),
  ratio: 1.9166666666666667,
  multiColor: false
});
export var LogoSberPayStroked = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoSberPayStroked.svg"),
  ratio: 1.9166666666666667,
  multiColor: false
});
export var LogoSberbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoSberbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoSdco = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoSdco.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoSnapchatRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoSnapchatRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoSnapchatSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoSnapchatSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoSovcombank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoSovcombank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoSpb = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoSpb.svg"),
  multiColor: false
});
export var LogoTelegramRoundColor = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoTelegramRoundFilled.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoTelegramRoundMonochrome = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoTelegramRoundStroked.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoTelegramSquareColor = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoTelegramSquareFilled.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoTelegramSquareMonochrome = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoTelegramSquareStroked.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoTiktokRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoTiktokRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoTiktokSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoTiktokSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoTinkoff = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoTinkoff.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoTkbbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoTkbbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoTochkabank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoTochkabank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoUnicreditbank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoUnicreditbank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoUnionPay = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoUnionPay.svg"),
  ratio: 1.9166666666666667,
  multiColor: false
});
export var LogoUralsib = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoUralsib.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoVKMusicRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVKMusicRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVKMusicSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVKMusicSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVKPlayRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVKPlayRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVKPlaySquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVKPlaySquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVKVideoRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVKVideoRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVKVideoSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVKVideoSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVisa = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVisa.svg"),
  ratio: 1.9166666666666667,
  multiColor: false
});
export var LogoVkClipsRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVkClipsRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVkClipsSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVkClipsSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVkRoundColor = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVkRoundColor.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVkRoundMonochrome = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVkRoundMonochrome.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVkSquareColor = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVkSquareColor.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVkSquareMonochrome = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVkSquareMonochrome.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoVkpay = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVkpay.svg"),
  ratio: 1.9166666666666667,
  multiColor: false
});
export var LogoVtb = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoVtb.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoWbBank = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoWbBank.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoWebmoney = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoWebmoney.svg"),
  defaultSize: 44,
  multiColor: false
});
export var LogoWechatRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoWechatRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoWechatSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoWechatSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoWhatsappRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoWhatsappRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoWhatsappSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoWhatsappSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYaDiskRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYaDiskRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYaDiskSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYaDiskSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYaMapsRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYaMapsRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYaMapsSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYaMapsSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYaMarketRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYaMarketRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYaMarketSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYaMarketSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexMusicRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexMusicRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexMusicSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexMusicSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexNavigatorRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexNavigatorRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexNavigatorSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexNavigatorSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexPay = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexPay.svg"),
  ratio: 1.9166666666666667,
  multiColor: false
});
export var LogoYandexProRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexProRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexProSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexProSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexTaxiRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexTaxiRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexTaxiSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexTaxiSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexZenRound = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexZenRound.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYandexZenSquare = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYandexZenSquare.svg"),
  defaultSize: 56,
  multiColor: false
});
export var LogoYoomoney = defineUrlIcon({
  url: "".concat(baseServerUrl, "/logos/LogoYoomoney.svg"),
  defaultSize: 44,
  multiColor: false
});